export default class ExportTools {
  static exportToCsv(fName, rows) {
    var csv = '';
    for (var i = 0; i < rows.length; i++) {
      var row = rows[i];
      for (var j = 0; j < row.length; j++) {
        var val =
          row[j] === null || typeof row[j] === 'undefined'
            ? ''
            : row[j].toString();
        val = val.replace(/\t/gi, ' ');
        if (j > 0) csv += '\t';
        csv += val;
      }
      csv += '\n';
    }

    // this allows support for multiple languages
    var cCode,
      bArr = [];
    bArr.push(255, 254);
    for (var i = 0; i < csv.length; ++i) {
      cCode = csv.charCodeAt(i);
      bArr.push(cCode & 0xff);
      bArr.push((cCode / 256) >>> 0);
    }

    var blob = new Blob([new Uint8Array(bArr)], {
      type: 'text/csv;charset=UTF-16LE;'
    });
    if (navigator.msSaveBlob) {
      navigator.msSaveBlob(blob, fName);
    } else {
      var link = document.createElement('a');
      if (link.download !== undefined) {
        var url = window.URL.createObjectURL(blob);
        link.setAttribute('href', url);
        link.setAttribute('download', fName);
        link.style.visibility = 'hidden';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
      }
    }
  }

  static exportToRealCsv(fName, rows) {
    var csv = '';
    for (var i = 0; i < rows.length; i++) {
      var row = rows[i];
      for (var j = 0; j < row.length; j++) {
        var val =
          row[j] === null || typeof row[j] === 'undefined'
            ? ''
            : row[j].toString();

        // Escape existing double quotes and wrap everything in double quotes
        val = '"' + val.replace(/"/g, '""') + '"';

        if (j > 0) csv += ',';
        csv += val;
      }
      csv += '\n';
    }

    // Include the UTF-8 BOM so Excel/Numbers automatically recognize the comma delimiter & characters
    var blob = new Blob([new Uint8Array([0xEF, 0xBB, 0xBF]), csv], {
      type: 'text/csv;charset=utf-8;'
    });

    if (navigator.msSaveBlob) {
      navigator.msSaveBlob(blob, fName);
    } else {
      var link = document.createElement('a');
      if (link.download !== undefined) {
        var url = window.URL.createObjectURL(blob);
        link.setAttribute('href', url);
        link.setAttribute('download', fName);
        link.style.visibility = 'hidden';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
      }
    }
  }

  static exportReportingToCsv(eventObject) {
    if (!eventObject) return;

    const eventName = eventObject.name || 'Event';
    const startDate = eventObject.selectedStartDate || eventObject.startDate || eventObject.eventStartDate || 'N/A';
    const endDate = eventObject.selectedEndDate || eventObject.endDate || eventObject.eventEndDate || 'N/A';
    const qrScans = eventObject.qrCodeScans || eventObject.qr_code_scans || 0;
    const leads = eventObject.engagements || 0;

    // Pad all rows to exactly 8 columns so Excel/Sheets correctly aligns the structure from the first row
    const csvRows = [
      [`Event Report:`, `${eventName} (ID: ${eventObject.id || ''})`, '', '', '', '', '', ''],
      [`Reporting Period:`, `${startDate} to ${endDate}`, '', '', '', '', '', ''],
      [`Total QR Scans`, qrScans, '', '', '', '', '', ''],
      [`Total Leads`, leads, '', '', '', '', '', ''],
      ['', '', '', '', '', '', '', ''],
      [
        'Zip Code', 'Zip Total', '',
        'Wireless Provider', 'Wireless Total', '',
        'Home Provider', 'Home Total'
      ]
    ];

    const zips = eventObject.leads_zip || [];
    const wireless = eventObject.leads_wireless || [];
    const providers = eventObject.leads_provider || [];

    const maxLength = Math.max(zips.length, wireless.length, providers.length);

    for (let i = 0; i < maxLength; i++) {
      const zipItem = zips[i] || {};
      const wirelessItem = wireless[i] || {};
      const providerItem = providers[i] || {};

      csvRows.push([
        zipItem.zip_code || '',
        zipItem.total || '',
        '',
        wirelessItem.provider_name || '',
        wirelessItem.total || '',
        '',
        providerItem.provider_name || '',
        providerItem.total || ''
      ]);
    }

    // Use our new real Comma-Separated Exporter
    this.exportToRealCsv(`${eventName} - Event Report.csv`, csvRows);
  }
}
